import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

import Box from '../box/box.jsx';
import PlayButton from '../../containers/play-button.jsx';
import styles from './library-item.css';
import classNames from 'classnames';

import bluetoothIconURL from './bluetooth.svg';
import internetConnectionIconURL from './internet-connection.svg';

/* eslint-disable react/prefer-stateless-function */
class LibraryItemComponent extends React.PureComponent {
    render() {
        return this.props.featured ? (
            <div
                className={classNames(
                    styles.libraryItem,
                    styles.featuredItem,
                    {
                        [styles.disabled]: this.props.disabled
                    },
                    this.props.extensionId ? styles.libraryItemExtension : null,
                    this.props.hidden ? styles.hidden : null
                )}
                onClick={this.props.onClick}
            >
                {/* Image area */}
                <div className={styles.featuredImageContainer}>
                    {this.props.disabled ? (
                        <div className={styles.comingSoonText}>
                            <FormattedMessage
                                defaultMessage="Coming Soon"
                                description="Label for extensions that are not yet implemented"
                                id="gui.extensionLibrary.comingSoon"
                            />
                        </div>
                    ) : null}
                    <img
                        className={styles.featuredImage}
                        src={this.props.iconURL}
                    />
                    {/* Hover overlay CTA */}
                    <div className={styles.hoverOverlay}>
                        <div className={styles.selectBadge}>
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M5 12h14M12 5l7 7-7 7"/>
                            </svg>
                            {'Select'}
                        </div>
                    </div>
                </div>

                {/* Text body: icon + name in same row, then description */}
                <div className={classNames(styles.featuredText, this.props.extensionId ? styles.featuredExtensionText : null)}>
                    <div className={styles.titleRow}>
                        {this.props.insetIconURL ? (
                            <div className={styles.libraryItemInsetImageContainer}>
                                <img
                                    className={styles.libraryItemInsetImage}
                                    src={this.props.insetIconURL}
                                />
                            </div>
                        ) : null}
                        <span className={styles.libraryItemName}>{this.props.name}</span>
                    </div>
                    <span className={styles.featuredDescription}>{this.props.description}</span>
                </div>

                {/* Metadata footer — always visible with fallback defaults */}
                <div className={styles.featuredExtensionMetadata}>
                    {/* Requires column */}
                    <div className={styles.featuredExtensionRequirement}>
                        <div className={styles.metaLabel}>
                            <FormattedMessage
                                defaultMessage="Requires"
                                description="Label for extension hardware requirements"
                                id="gui.extensionLibrary.requires"
                            />
                        </div>
                        <div className={styles.featuredExtensionMetadataDetail}>
                            {this.props.bluetoothRequired ? (
                                <img src={bluetoothIconURL} />
                            ) : null}
                            {this.props.internetConnectionRequired ? (
                                <img src={internetConnectionIconURL} />
                            ) : null}
                            {!this.props.bluetoothRequired && !this.props.internetConnectionRequired ? (
                                <span className={styles.metaNone}>{'None'}</span>
                            ) : null}
                        </div>
                    </div>
                    {/* Developed by column */}
                    <div className={styles.featuredExtensionCollaboration}>
                        <div className={styles.metaLabel}>
                            <FormattedMessage
                                defaultMessage="Developed by"
                                description="Label for extension collaboration"
                                id="gui.extensionLibrary.collaboration12"
                            />
                        </div>
                        <div className={styles.featuredExtensionMetadataDetail}>
                            {this.props.collaborator || 'Scratch'}
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <Box
                className={classNames(
                    styles.libraryItem, {
                    [styles.hidden]: this.props.hidden
                }
                )}
                role="button"
                tabIndex="0"
                onBlur={this.props.onBlur}
                onClick={this.props.onClick}
                onFocus={this.props.onFocus}
                onKeyPress={this.props.onKeyPress}
                onMouseEnter={this.props.showPlayButton ? null : this.props.onMouseEnter}
                onMouseLeave={this.props.showPlayButton ? null : this.props.onMouseLeave}
            >
                {/* Layers of wrapping is to prevent layout thrashing on animation */}
                <Box className={styles.libraryItemImageContainerWrapper}>
                    <Box
                        className={styles.libraryItemImageContainer}
                        onMouseEnter={this.props.showPlayButton ? this.props.onMouseEnter : null}
                        onMouseLeave={this.props.showPlayButton ? this.props.onMouseLeave : null}
                    >
                        <img
                        className={styles.libraryItemImage}
                        src={this.props.iconURL}
                        />
                    </Box>
                </Box>
                <span className={styles.libraryItemName}>{this.props.name}</span>
                {this.props.showPlayButton ? (
                    <PlayButton
                        isPlaying={this.props.isPlaying}
                        onPlay={this.props.onPlay}
                        onStop={this.props.onStop}
                    />
                ) : null}
            </Box>
        );

    }
}
/* eslint-enable react/prefer-stateless-function */


LibraryItemComponent.propTypes = {
    bluetoothRequired: PropTypes.bool,
    collaborator: PropTypes.string,
    description: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    disabled: PropTypes.bool,
    extensionId: PropTypes.string,
    featured: PropTypes.bool,
    hidden: PropTypes.bool,
    iconURL: PropTypes.string,
    insetIconURL: PropTypes.string,
    internetConnectionRequired: PropTypes.bool,
    isPlaying: PropTypes.bool,
    name: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    onBlur: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    onKeyPress: PropTypes.func.isRequired,
    onMouseEnter: PropTypes.func.isRequired,
    onMouseLeave: PropTypes.func.isRequired,
    onPlay: PropTypes.func.isRequired,
    onStop: PropTypes.func.isRequired,
    showPlayButton: PropTypes.bool
};

LibraryItemComponent.defaultProps = {
    disabled: false,
    showPlayButton: false
};

export default LibraryItemComponent;
